import 'noty/lib/noty.css'
import './noty-theme.less'
import Noty from 'noty'

const notyRegistry = new Map()

export const noty = (host, settings) => {
  return () => {
    const options = {
      ...notyRegistry.get(host),
      ...settings
    }

    const instance = new Noty(options)

    instance.on('onShow', () => {
      console.log.apply(console, (
        ['Notification', instance.options.queue, instance.options.type]
          .filter(v => !!v)
          .map(v => `[${v}]`)
          .concat([instance.options.text])
      ))
    })

    return instance
  }
}

export const registerNoty = (host, settings) => {
  notyRegistry.set(host, settings)
}



// WEBPACK FOOTER //
// ./~/vue-components/plugins/noty/noty.js